<script>
  import Input from '../../input-design/Input.svelte'
  import { redeemableStore, initialRedeemable } from '../../../../stores/redeemableStore'

  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  let fields = initialRedeemable()

  let errors = {
    tokenName: '',
    tokenSymbol: '',
    availableToken: '',
  }

  const validateRedeemableForm = () => {
    let valid = true
    window.scroll({ top: 0 })

    if (!fields.tokenName.trim()) {
      errors.tokenName = 'Token Name is required'
      valid = false
    }
    if (!fields.tokenSymbol.trim()) {
      errors.tokenSymbol = 'Token Symbol is required'
      valid = false
    }
    if (!fields.availableToken.trim()) {
      errors.availableToken = 'Available Token is required'
      valid = false
    }

    if (!valid) return

    errors = {
      tokenName: '',
      tokenSymbol: '',
      availableToken: '',
    }
    redeemableStore.setRedeemable({ ...fields })
    dispatch('next')
    return true
  }

  const clearForm = () => {
    fields = initialRedeemable()
    window.scroll({ top: 0 })
  }

</script>

<section>
  <form>
    <div class="flex flex-wrap form-row items-end">
      <div class="col-6">
        <Input
          bind:value={fields.tokenName}
          on:input={() => (errors = { ...errors, tokenName: '' })}
          error = {errors.tokenName}
          placeholder="Enter token name">
          <label slot="label" class="form-label">
            Token Name
            <small>*</small>
          </label>
        </Input>
        <div class="error">{errors.tokenName}</div>
      </div>
      <div class="col-6">
        <Input
                bind:value={fields.tokenSymbol}
                on:input={() => (errors = { ...errors, tokenSymbol: '' })}
                error = {errors.tokenSymbol}
                placeholder="Enter token symbol">
          <label slot="label" class="form-label">
            Token Symbol
            <small>*</small>
          </label>
        </Input>
        <div class="error">{errors.tokenSymbol}</div>
      </div>
      <div class="col-6">
        <Input
                bind:value={fields.availableToken}
                on:input={() => (errors = { ...errors, availableToken: '' })}
                error = {errors.availableToken}
                placeholder="Enter available token">
          <label slot="label" class="form-label">
            Total Available Token
            <small>*</small>
          </label>
        </Input>
        <div class="error">{errors.availableToken}</div>
      </div>
    </div>
  </form>
</section>
<div class="pl-button-wrapper">
  <button class="pl-button pl-clear-btn" on:click={() => dispatch('back')}>Back</button>
  <button
          class="pl-button pl-next-btn"
          type="submit"
          on:click={validateRedeemableForm}>
    Next
  </button>
</div>